import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { admissionFlowSteps } from '@/mocks/admissionData';

export default function AdmissionFlow() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('admission.flow.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('admission.flow.title')}
          </h2>
          {String(t('admission.flow.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          {String(t('admission.flow.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4">
          {admissionFlowSteps.map((step, idx) => (
            <div key={idx} className="relative">
              <div className="card-glow h-full bg-background-50 border border-background-200/60 p-5 text-center group">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 mb-4">
                  <span className="text-accent-600 text-[13px] tracking-[0.08em] font-medium">{step.step}</span>
                </div>
                <i className={`${step.icon} text-accent-500 text-xl block mb-3`}></i>
                <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-1">
                  {lang === 'en' ? t(`admission.flow.step.${idx}.title`) : step.title}
                </h3>
                <p className="text-[12px] text-foreground-400 tracking-[0.08em] mb-3 font-label">
                  {step.titleEn}
                </p>
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                  {lang === 'en' ? t(`admission.flow.step.${idx}.desc`) : step.description}
                </p>
                {!step.required && (
                  <div className="mt-3 inline-block px-2 py-0.5 border border-foreground-300/30 text-[12px] text-foreground-400 tracking-[0.05em]">
                    {t('admission.flow.optionalBadge')}
                  </div>
                )}
                {step.required && (
                  <div className="mt-3 inline-block px-2 py-0.5 border border-accent-500/30 text-[12px] text-accent-600 tracking-[0.05em]">
                    {t('admission.flow.requiredBadge')}
                  </div>
                )}
              </div>
              {idx < admissionFlowSteps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-[1px] bg-accent-400/30 z-10"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
